export default __webpack_public_path__ + "static/media/ic_usdt_40.d7851f5e.svg";